/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import { ReactComponent as Icon } from 'Images/minibot.svg';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  width: 264px;
  height: 38px;
  padding-left: 10px;
  gap: 10px;
  background: ${({ theme }) => theme.backgrounds.listItemOdd};
`;
Wrapper.displayName = 'Wrapper';

export const AgentIcon = styled(Icon)`
    path {
      fill: ${({ theme }) => theme.icons.actionBar.color};
    }
`;
AgentIcon.displayName = 'AgentIcon';

export const agentSelect = (theme) => ({
  control: () => ({
    height: '32px',
    border: 'none',
    backgroundColor: theme.backgrounds.workspaceItem,
    left: '16px',
    fontSize: '12.5px',
    fontWeight: '500',
    color: theme.text.eorDropdown,
    width: '220px',
    paddingLeft: '10px'
  }),

  indicatorSeparator: () => ({
    display: 'none'
  }),

  dropdownIndicator: () => ({
    position: 'absolute',
    top: '7px',
    right: '6px',
    color: theme.text.eorDropdownIcon
  }),

  option: (provided, state) => ({
    ...provided,
    fontSize: '14px',
    textAlign: 'left',
    cursor: state.isSelected ? 'default' : 'pointer',
    paddingLeft: '22px',
    height: '36px',
    fontWeight: state.selectProps.value.value === state.value ? 900 : 400,
    color: theme.text.actionDropDownItem,
    backgroundColor: state.isFocused ? theme.backgrounds.dropdown1OptionsHover : theme.backgrounds.dropdown1Options
  }),

  menu: () => ({
    position: 'absolute',
    zIndex: 5000,
    border: 'none',
    borderRadius: '3px',
    backgroundColor: theme.backgrounds.dropdown1Options,
    boxShadow: `2px 2px 30px 0 ${theme.shadows.actionDropDown}`,
    minWidth: '150px',
    width: '100%'
  }),

  valueContainer: () => ({
    top: '4px',
    color: theme.text.eorDropdown
  }),

  menuList: () => ({
    maxHeight: '250px',
    overflowX: 'auto',
    borderRadius: '3px',
    paddingTop: '17px',
    paddingBottom: '13px'
  }),

  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';
    return {
      ...provided, opacity, transition, color: theme.text.eorDropdown, width: 'fit-content', fontSize: '13.5px', fontWeight: 500, left: '16px'
    };
  }
});
agentSelect.displayName = 'agentSelect';
